<template>
  <BAutocompleteSelect
    ref="autocomplete"
    :key="type"
    v-bind="$attrs"
    :value="value"
    :disabled="disabled || !options.length"
    :label="options.length ? 'Способ заполнения' : 'нет вариантов'"
    no-data-text="Способ не найден"
    :options="options"
    :return-object="false"
    item-text="label"
    item-value="value"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import {
  SheetCellTypes,
  SheetCellTypesOptions,
} from '@/typings/api/FormTemplate'

import BAutocompleteSelect from './BAutocompleteSelect.vue'


export default {
  name: 'BAutocompleteSheetCellTypeMethod',
  components: {
    BAutocompleteSelect,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    value: String,
    disabled: Boolean,
    type: {
      type: String,
      validate: (prop) => Object.values(SheetCellTypes).includes(prop),
    },
  },
  computed: {
    required() {
      const { validate } = this.$attrs

      return typeof validate === 'string'
        ? validate.includes('required')
        : validate?.required
    },
    options() {
      return Object.values(SheetCellTypesOptions)
        .find((_) => _.value === this.type)
        ?.children || []
    },
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        if (!this.required) return

        const type = this.value
        const valid = this.options.some((_) => _.value === type)

        if (valid) return
        const { value } = this.options[0] || {}

        this.$emit('input', value)
      },
    },
  },
}
</script>
